import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import SectionHeading from "@/components/SectionHeading";
import Gallery from "@/components/Gallery";
import HeroSection from "@/components/HeroSection";

const Dekor = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-grow">
        <HeroSection
          title="Keramične ploščice Dekor"
          subtitle="Unikatni vzorci za posebne prostore"
          imageSrc="/placeholder.svg"
          primaryButtonText="Zahtevaj ponudbo"
          primaryButtonLink="/kontakt"
        />
        
        <div className="container-custom mx-auto py-16">
          <SectionHeading
            title="Dekor"
            subtitle="Unikatni vzorci za posebne prostore"
          />
          
          <div className="mt-8 prose prose-lg max-w-none">
            <p>
              Naše dekorativne ploščice ponujajo širok nabor vzorcev, barv in tekstur za ustvarjanje edinstvenih prostorov.
              Idealne so za poudarjene stene, kuhinjske obloge in druge površine, kjer želite dodati osebni pečat.
            </p>
          </div>
          
          <Gallery
            images={[
              { src: "/placeholder.svg", alt: "Dekor ploščice 1" },
              { src: "/placeholder.svg", alt: "Dekor ploščice 2" },
              { src: "/placeholder.svg", alt: "Dekor ploščice 3" },
              { src: "/placeholder.svg", alt: "Dekor ploščice 4" },
            ]}
          />
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Dekor;